import app from './app';
import Constants from '../utils/CommonConstants';

let routes = {};

app.config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    'cartonomyConfig',
    function ($stateProvider, $urlRouterProvider, $locationProvider, cartonomyConfig) {
        $locationProvider.hashPrefix('');

        $urlRouterProvider.otherwise(
            async function ($injector, $location) {
                const url = $location.absUrl();

                let match = url.match(/(.*)\?externalLogin=([a-z]+)&code=(.*)/);

                if (match) {
                    location.href = match[ 1 ] + '#/externalLogin/' + match[ 2 ] + '/' + match[ 3 ];
                    return;
                }

                match = url.match(/(.*)\?success=true&token=([^&]+)&PayerID=(.+)/);

                if (match) {
                    location.href = match[ 1 ] + '#/paypal/' + match[ 2 ] + '/' + match[ 3 ];
                    return;
                }

                match = url.match(/(.*)\?cancel=true&token=(.*)/);

                if (match) {
                    location.href = match[ 1 ]; // currently we don't show any message for cancelled PayPal transaction
                    return;
                }

                let sessionService = $injector.get('Session');
                let authenticationService = $injector.get('AuthenticationService');

                if (!cartonomyConfig.externalStoreMode) {
                    $location.url('/catalog');
                } else {
                    if (await sessionService.loggedIn()) {
                        $location.url('/profile');
                    }
                }
            });

        // only register catalog page if not in shopify integration
        if (!cartonomyConfig.externalStoreMode) {
            $stateProvider
                .state({
                    name: Constants.RoutingStates.CATALOG,
                    url: "/catalog",
                    views: {
                        contents: {
                            template: require("../modules/catalog/views/categoryView.jade"),
                            controller: 'Cartonomy.Catalog.CategoryController'
                        }
                    }
                });
        }

        $stateProvider
            .state({
                name: Constants.RoutingStates.USER_PROFILE,
                url: "/profile",
                windowTitle: 'client.profile',
                views: {
                    contents: {
                        template: require("../modules/profile/views/profileView.jade"),
                        controller: 'Cartonomy.Profile.ProfileController'
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.CHAT,
                url: "/chat",
                windowTitle: 'client.group.chat',
                views: {
                    contents: {
                        templateUrl: "modules/catalog/views/chatView.html",
                        controller: "Cartonomy.Catalog.ChatViewController"
                    }
                }
            })


            .state({
                name: Constants.RoutingStates.CONFIRM_TICKET,
                url: "/resetpassword/{ticket}",
                views: {
                    contents: {
                        templateUrl: "modules/shared/views/confirmTicket.html",
                        controller: "Cartonomy.Shared.ConfirmTicketController"
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.CHECKOUT,
                url: "/checkout",
                views: {
                    contents: {
                        templateUrl: "modules/order/views/orderCheckout.html",
                        controller: "Cartonomy.Order.CheckoutController"
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.CHECKOUT_FULL_MIXED,
                url: "/checkout_fullmixed",
                views: {
                    contents: {
                        templateUrl: "modules/order/views/orderCheckoutFullMixed.html",
                        controller: "Cartonomy.Order.CheckoutFullMixedController"
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.PAY,
                url: "/pay/{id}",
                views: {
                    contents: {
                        templateUrl: "modules/order/views/orderPay.html",
                        controller: "Cartonomy.Order.PayController"
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.LOGIN_TICKET,
                url: "/auth_token={authToken}?errorMessage",
                views: {
                    contents: {
                        controller: "Cartonomy.Shared.LoginTicketController"
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.PAYPAL_REDIRECT,
                url: "/paypal/{token}/{externalPayerId}",
                views: {
                    contents: {
                        templateUrl: 'modules/catalog/views/categoryView.html',
                        controller: 'Cartonomy.Catalog.CategoryController'
                    }
                }
            })

            .state({
                name: Constants.RoutingStates.CONFIRM_ORDER,
                url: "/confirm_order",
                views: {
                    contents: {
                        templateUrl: "modules/order/views/orderConfirmation.html",
                        controller: "Cartonomy.Order.ConfirmationController"
                    }
                }
            });
    }
]);

export default routes;



// WEBPACK FOOTER //
// ./src/bootstrap/routes.js